export const UrlUtil = {
	getQueryString(url: string): Map<string, string[]> {
		if (!url) {
			return new Map();
		}

		const hashIdx = url.indexOf("#");
		const withoutHash = hashIdx === -1 ? url : url.substring(0, hashIdx);
		const qsIdx = withoutHash.indexOf("?");
		const qs = qsIdx === -1 ? "" : withoutHash.substring(qsIdx + 1);

		return qs
			.split("&")
			.filter(Boolean)
			.map(kvp => kvp.split("=").map(decodeURIComponent))
			.reduce((prev, next) => {
				const existing = prev.get(next[0]);
				if (existing) {
					existing.push(next[1]);
				} else {
					prev.set(next[0], [next[1]]);
				}

				return prev;
			}, new Map<string, string[]>());
	},

	setUniqueQueryString(url: string): string {
		if (!url) {
			return url;
		}

		const hashIdx = url.indexOf("#");
		const hash = hashIdx === -1 ? "" : url.substring(hashIdx);
		const withoutHash = hashIdx === -1 ? url : url.substring(0, hashIdx);

		const qsIdx = withoutHash.indexOf("?");
		const qs = qsIdx === -1 ? "" : withoutHash.substring(qsIdx + 1);
		const baseUrl =
			qsIdx === -1 ? withoutHash : withoutHash.substring(0, qsIdx);

		const updatedQs =
			"?" +
			qs
				.split("&")
				.filter(Boolean)
				.map(kvp => kvp.split("=").map(decodeURIComponent))
				.map(kvp => ({ name: kvp[0], value: kvp[1] }))
				.filter(kvp => kvp.name !== "ts")
				.concat({
					name: "ts",
					value: new Date().valueOf().toString()
				})
				.map(kvp => [kvp.name, kvp.value])
				.map(kvp => kvp.map(encodeURIComponent).join("="))
				.join("&");

		return baseUrl + updatedQs + hash;
	}
};
